import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "g-treeview" };
const _hoisted_2 = { class: "tree-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_treeview_item = _resolveComponent("g-treeview-item");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.dataSource)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.nodes, (node) => {
                    return (_openBlock(), _createBlock(_component_g_treeview_item, {
                        level: 1,
                        label: node.caption,
                        "data-item": node,
                        "get-children": _ctx.getChildren,
                        "has-children": _ctx.hasChildren
                    }, null, 8, ["label", "data-item", "get-children", "has-children"]));
                }), 256))
                : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "children")
        ])
    ]));
}
